export default __webpack_public_path__ + "static/media/walletConnect.ac9b8744.svg";